import {
  Box,
  Button,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Grid,
  TextField,
  Typography
} from '@mui/material';
import moment from 'moment';
import { useState } from 'react';
import { useFieldTranslation } from 'src/components/fields/useFieldTranslation';
import { usePreferedDateFormat } from 'src/util/DateFormatter';
import { formatInput } from 'src/util/STR';
import { ButtonComponent } from './ButtonComponent';
import { PopupComponent } from './PopupComponent';
import { StackComponent } from './StackComponent';

export default function Notes(props: any) {
  const { userPreferedDateFormat } = usePreferedDateFormat();
  const { DOA, unSavedWarning } = useFieldTranslation();
  const [temp, setTemp] = useState<boolean>(true);
  const [tooltipOpen, setTooltipOpen] = useState<boolean>(false);
  const handleNoteChange = (e: any) => {
    const data = e.target.value;
    const formattedVal = typeof data === 'string' ? formatInput(data) : data;
    props.setNoteText(formattedVal);
  };
  const handleSave = () => {
    props.handleSendNote();
    setTemp(!temp);
  };
  const handleClose = () => {
    props.setNoteText('');
    props.setCommentDilogOpen(false);
  };
  const tooltipCloseHandle = () => {
    setTooltipOpen(false);
  };
  const handleOk = () => {
    setTooltipOpen(false);
    handleClose();
  };
  const handleClosePopUp = () => {
    if (props?.notetext) {
      setTooltipOpen(true);
    } else {
      handleClose();
    }
  };
  return (
    <div>
      <PopupComponent
        open={props.commentDilogOpen}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        // className="raisefield-modal"
        maxWidth="md"
      >
        <DialogTitle id="alert-dialog-title">Notes</DialogTitle>
        <DialogContent sx={{ minWidth: '800px' }}>
          <Grid container rowSpacing={1} columnSpacing={{ xs: 2, sm: 1, md: 1 }}>
            <Grid item xs>
              <TextField
                label="Add notes"
                fullWidth
                value={props?.notetext}
                variant="standard"
                inputProps={{ maxLength: 2000 }}
                disabled={!props.permission}
                onChange={e => handleNoteChange(e)}
              />
            </Grid>
            <Grid item sx={{ width: '64px' }}>
              <Button onClick={handleSave} sx={{ mt: 1 }} disabled={!props.permission || props?.notetext === ''}>
                SEND
              </Button>
            </Grid>
          </Grid>
          {props &&
            props?.notesData &&
            props?.notesData != null &&
            props?.notesData.map((ele: any) => (
              <Box key={ele.id}>
                <Typography variant="h6" mt={2} mb={0} sx={{ fontSize: '16px' }}>
                  {ele.da_log_kit_notes_user} - {ele.da_log_kit_notes_role}
                  <span className="NoteDate">
                    {moment(ele.da_log_kit_notes_date).format(`${userPreferedDateFormat.toUpperCase()} h:mm A`)}
                  </span>
                </Typography>
                <Typography variant="body2" gutterBottom mt={0.5}>
                  {ele.da_log_kit_notes}
                </Typography>
              </Box>
            ))}
        </DialogContent>
        <DialogActions>
          <StackComponent direction="row" spacing={2} mt={2}>
            <ButtonComponent variant="text" className="grey-btn" onClick={handleClosePopUp}>
              close
            </ButtonComponent>
          </StackComponent>
        </DialogActions>
      </PopupComponent>
      <PopupComponent open={tooltipOpen} child className="confirm-modal">
        <DialogTitle id="alert-dialog-title">{'Confirm Exit'}</DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">{unSavedWarning}</DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={tooltipCloseHandle} className="grey-btn">
            {DOA.label23}
          </Button>
          <Button onClick={handleOk} autoFocus>
            {DOA.label22}
          </Button>
        </DialogActions>
      </PopupComponent>
    </div>
  );
}
